import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

const bottomNav = [
  { to: "/", label: "首页", icon: "ri-home-5-line" },
  { to: "/category/urban", label: "分类", icon: "ri-apps-2-line" },
  { to: "/news", label: "资讯", icon: "ri-newspaper-line" },
  { to: "/search", label: "搜索", icon: "ri-search-line" },
];

export default function Layout() {
  const { pathname } = useLocation();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  useEffect(() => {
    function onScroll() {
      setShowTop(window.scrollY > 600);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <Header />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />

      <div className="md:hidden h-14" />

      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 h-14 bg-background-50 border-t border-background-200 flex items-center justify-around">
        {bottomNav.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full cursor-pointer text-xs ${
              pathname === item.to ? "text-primary-600" : "text-foreground-500"
            }`}
          >
            <i className={`${item.icon} text-xl`} />
            {item.label}
          </Link>
        ))}
      </nav>

      <button
        type="button"
        aria-label="返回顶部"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed right-4 md:right-6 bottom-20 md:bottom-8 z-40 w-11 h-11 rounded-full bg-primary-600 text-background-50 flex items-center justify-center text-xl hover:bg-primary-700 transition-all cursor-pointer ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line" />
      </button>
    </div>
  );
}